<template>
    <div id="panel-1" class="panel">
        <div class="panel-hdr">
            <h2>
                Accept <span class="fw-300"><i> Order</i></span>
            </h2>
            <div class="panel-toolbar">
                <a href="javascript:void(0)"
                    class="btn btn-sm btn-success mx-1"
                    data-toggle="tooltip" 
                    data-offset="0,10" 
                    data-original-title="Accept Order"
                    @click="acceptOrder">
                    <i class="fal fa-check"></i>
                    Accept
                </a>
                <a :href="appUrl+'/seller/orders'"
                    class="btn btn-sm btn-danger mx-1"
                    data-toggle="tooltip"
                    data-offset="0,10" 
                    data-original-title="Cancel">
                    <i class="fal fa-times"></i>
                    Cancel
                </a>
            </div>
        </div>
        <div class="panel-container show">
            <div class="panel-content">
                <div class="card-deck my-3">
                    <div class="card">
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>Order Number: </b>
                                </div>
                                <div class="col-8">
                                    {{ order.order_number }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>Order Time: </b>
                                </div>
                                <div class="col-8">
                                    {{ order.transaction_date }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>Payment Mode: </b>
                                </div>
                                <div class="col-8">
                                    <span v-if="order.payment_method == 'UPI'">Prepaid</span>
                                    <span v-else-if="order.payment_method == 'COD'">POD</span>
                                    <span v-else>{{ order.payment_method }}</span>
                                    <span :class="'badge badge-'+order.status_class_razorpay"
                                        v-if="order.payment_method == 'UPI' && order.razorpay_payment_status">
                                        {{ order.razorpay_payment_status }}
                                    </span>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>Order Status: </b>
                                </div>
                                <div class="col-8">
                                    <span :class="'font-badge badge badge-'+order.status_class">
                                        {{ order.status }}
                                    </span>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>Route: </b>
                                </div>
                                <div class="col-8">
                                    <span v-if="order.route">{{ order.route.title }}</span>
                                    <span v-else>Not Assigned</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>Customer Name: </b>
                                </div>
                                <div class="col-8">
                                    {{ order.retailer.shop_name }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>Customer Code: </b>
                                </div>
                                <div class="col-8">
                                    {{ order.retailer.retailer_id }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>User Mobile: </b>
                                </div>
                                <div class="col-8">
                                    {{ order.retailer.phone }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>Delivery Address: </b>
                                </div>
                                <div class="col-8">
                                    {{ order.shop_address }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>City: </b>
                                </div>
                                <div class="col-8">
                                    {{ order.address.city }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered" width="100%" cellspacing="0">
                        <thead>
                            <tr>
                                <th>Product Code</th>
                                <th class="w-25">Product Name</th>
                                <th>MRP</th>
                                <th>Quantity</th>
                                <th class="bg-success-50">Accepted Quantity</th>
                                <th class="bg-primary-50">Pending Quantity</th>
                                <th>Rate</th>
                                <th>Value</th>
                                <th class="bg-success-50">Accepted Value</th>
                                <th class="bg-primary-50">Pending Value</th>
                            </tr>
                        </thead>
                        <tbody v-if="items.length > 0">
                            <tr v-for="(item, key) in items" :key="item.id">
                                <td>{{ item.product.tpc }}</td>
                                <td>{{ item.product.title }}</td>
                                <td>
                                    <i class="fal fa-rupee-sign"></i>
                                    {{ item.product.mrp | number_format }}
                                </td>
                                <td>{{ item.quantity }}</td>
                                <td class="bg-success-50">
                                    <input type="number" 
                                        class="form-control"
                                        min="0"
                                        step="1"
                                        :max="item.quantity"
                                        v-model.number="item.quantity_updated"
                                        @input="calculateTotals(key)">
                                </td>
                                <td class="bg-primary-50">{{ item.quantity - item.quantity_updated }}</td>
                                <td>
                                    <i class="fal fa-rupee-sign"></i>
                                    {{ item.unit_price | number_format }}
                                </td>
                                <td>
                                    <i class="fal fa-rupee-sign"></i>
                                    {{ item.item_total | number_format }}
                                </td>
                                <td class="bg-success-50">
                                    <i class="fal fa-rupee-sign"></i>
                                    <span class="updated-total">{{ item.item_total_updated | number_format }}</span>
                                </td>
                                <td class="bg-primary-50">
                                    <i class="fal fa-rupee-sign"></i>
                                    <span class="updated-total">{{ item.item_total - item.item_total_updated.toFixed(2) | number_format }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="7" class="text-right">Subtotal</td>
                                <td>
                                    <i class="fal fa-rupee-sign"></i>
                                    {{ order.subtotal | number_format }}
                                </td>
                                <td class="bg-success-50">
                                    <i class="fal fa-rupee-sign"></i>
                                    <span class="updated-subtotal">{{ subtotal | number_format }}</span>
                                </td>
                                <td class="bg-primary-50">
                                    <i class="fal fa-rupee-sign"></i>
                                    <span class="updated-subtotal">{{ order.subtotal - subtotal.toFixed(2) | number_format }}</span>
                                </td>
                            </tr>
                            <tr v-if="order.discount > 0">
                                <td colspan="7" class="text-right">
                                    <div class="fw-500">Discount</div>
                                    <ul class="list-unstyled mb-0" v-if="order.transaction_offers.length > 0">
                                        <li v-for="offer in order.transaction_offers" :key="offer.id">
                                            <span class="fs-nano" v-if="offer.type == 'cart'">
                                                Cart Discount
                                            </span>
                                            <span class="fs-nano" v-else>
                                                {{ offer.brand_name }} Brand Discount
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                                <td>
                                    <div class="fw-500">
                                        <i class="fal fa-rupee-sign"></i>
                                        {{ order.discount | number_format }}
                                    </div>
                                    <ul class="list-unstyled mb-0" v-if="order.transaction_offers.length > 0">
                                        <li v-for="offer in order.transaction_offers" :key="offer.id">
                                            <span class="fs-nano" v-if="offer.type == 'cart'">
                                                <i class="fal fa-rupee-sign"></i>
                                                {{ order.cart_discount | number_format }}
                                            </span>
                                            <span class="fs-nano" v-else-if="offer.options.discount_type == 3">
                                                {{ offer.options.discount }}
                                            </span>
                                            <span class="fs-nano" v-else>
                                                <i class="fal fa-rupee-sign"></i>
                                                {{ offer.options.discount | number_format }}
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                                <td class="bg-success-50">
                                    <div class="fw-500">
                                        <i class="fal fa-rupee-sign"></i>
                                        <span class="updated-discount">{{ discount | number_format }}</span>
                                    </div>
                                    <ul class="list-unstyled mb-0" v-if="offers.length > 0">
                                        <li v-for="offer in offers" :key="offer.id">
                                            <span class="fs-nano" v-if="offer.type == 'cart'">
                                                <i class="fal fa-rupee-sign"></i>
                                                {{ cart_discount | number_format }}
                                            </span>
                                            <span class="fs-nano" v-else-if="offer.options.discount_type == 3">
                                                <span v-if="updatedBrands[offer.options.brand_id] > 0">{{ offer.options.discount }}</span>
                                            </span>
                                            <span class="fs-nano" v-else>
                                                <i class="fal fa-rupee-sign"></i>
                                                {{ offer.options.discount | number_format }}
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                                <td class="bg-primary-50">
                                    <div class="fw-500">
                                        <i class="fal fa-rupee-sign"></i>
                                        <span class="updated-discount">{{ order.discount - discount | number_format }}</span>
                                    </div>
                                    <ul class="list-unstyled mb-0" v-if="offers.length > 0">
                                        <li v-for="offer, key in offers" :key="offer.id">
                                            <span class="fs-nano" v-if="offer.type == 'cart'">
                                                <i class="fal fa-rupee-sign"></i>
                                                {{ order.cart_discount - cart_discount | number_format }}
                                            </span>
                                            <span class="fs-nano" v-else-if="offer.options.discount_type == 3">
                                                <span v-if="updatedBrands[offer.options.brand_id] == 0">{{ order.transaction_offers[key].options.discount }}</span>
                                            </span>
                                            <span class="fs-nano" v-else>
                                                <i class="fal fa-rupee-sign"></i>
                                                {{ order.transaction_offers[key].options.discount - offer.options.discount.toFixed(2) | number_format }}
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr v-if="order.delivery_charge > 0">
                                <td colspan="7" class="text-right">Delivery Charge</td>
                                <td>
                                    <i class="fal fa-rupee-sign"></i>
                                    {{ order.delivery_charge | number_format }}
                                </td>
                                <td class="bg-success-50">
                                    <i class="fal fa-rupee-sign"></i>
                                    <span class="updated-delivery-charge">{{ delivery_charge | number_format }}</span>
                                </td>
                                <td class="bg-primary-50">
                                    <i class="fal fa-rupee-sign"></i>
                                    <span class="updated-delivery-charge">{{ order.delivery_charge - delivery_charge.toFixed(2) | number_format }}</span>
                                </td>
                            </tr>
                            <tr v-if="order.account_credit > 0">
                                <td colspan="7" class="text-right">
                                    Accounts Credit <br>
                                    <span class="badge badge-dark">Pending credits will be refunded back to customer.</span>
                                </td>
                                <td>
                                    <i class="fal fa-rupee-sign"></i>
                                    {{ order.account_credit | number_format }}
                                </td>
                                <td class="bg-success-50">
                                    <i class="fal fa-rupee-sign"></i>
                                    <span class="updated-account-credit">{{ account_credit | number_format }}</span>
                                </td>
                                <td class="bg-primary-50">
                                    <i class="fal fa-rupee-sign"></i>
                                    <span class="updated-account-credit">{{ refundable_account_credit | number_format }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="7" class="text-right">Final Amount</td>
                                <td>
                                    <i class="fal fa-rupee-sign"></i>
                                    {{ order.total | number_format }}
                                </td>
                                <td class="bg-success-50">
                                    <i class="fal fa-rupee-sign"></i>
                                    <span class="updated-total">{{ total | number_format }}</span>
                                </td>
                                <td class="bg-primary-50">
                                    <i class="fal fa-rupee-sign"></i>
                                    <span class="updated-total">{{ order.total - total.toFixed(2) | number_format }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        computed: {},
        filters: {
            number_format: function (value){
                return parseFloat(value).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })
            }
        },
        props: {
            order: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
                items: [],
                offers: [],
                brands: {},
                updatedBrands: {},
                subtotal: 0,
                discount: 0,
                cart_discount: 0,
                delivery_charge: 0,
                account_credit: 0,
                refundable_account_credit: 0,
                total: 0,
            };
        },
        mounted() {
            let self = this;
            self.items = JSON.parse(JSON.stringify(self.order.items));
            self.offers = JSON.parse(JSON.stringify(self.order.transaction_offers));
            self.subtotal = self.order.subtotal;
            self.discount = self.order.discount;
            self.cart_discount = self.order.cart_discount;
            self.delivery_charge = self.order.delivery_charge;
            self.account_credit = self.order.account_credit;
            self.total = self.order.total;
            self.setBrands();
        },
        methods: {
            setBrands() {
                let self = this;
                self.order.items.forEach(item => {
                    if (item.product.brand_id in self.brands) {
                        self.brands[item.product.brand_id] += item.item_total; 
                    } else {
                        self.brands[item.product.brand_id] = item.item_total; 
                    }
                });
            },
            calculateTotals(key) {
                let self = this;
                let item = self.items[key];
                if (item) {
                    if (!/[\d\.]+/i.test(item.quantity_updated) || item.quantity_updated < 0 || item.quantity_updated > item.quantity) {
                        self.items[key].quantity_updated = item.quantity;
                    }
                    self.items[key].item_total_updated = item.quantity_updated * item.unit_price;
                    self.refundable_account_credit = 0;
                }
                self.refreshOrder()
            },
            refreshOrder() {
                let self = this;
                let subtotal = 0;
                let percentage = 0;
                let discount = 0;
                let brandPercentage = 0;
                let brandDiscount = 0;
                let cartDiscount = 0;
                if (self.items.length > 0) {
                    self.updatedBrands = {};
                    self.items.forEach(item => {
                        subtotal += item.item_total_updated;
                        if (item.product.brand_id in self.updatedBrands) {
                            self.updatedBrands[item.product.brand_id] += item.item_total_updated; 
                        } else {
                            self.updatedBrands[item.product.brand_id] = item.item_total_updated; 
                        }
                    });
                    self.subtotal = subtotal;
                    percentage = (self.subtotal / self.order.subtotal) * 100;

                    self.order.transaction_offers.forEach((offer, key) => {
                        if (offer.type == 'cart') {
                            cartDiscount = (self.order.cart_discount * percentage) / 100;
                            discount += cartDiscount;
                            self.cart_discount = cartDiscount;
                        }

                        if (offer.type == 'brand') {
                            if (offer.options.discount_type != 3) {
                                brandPercentage = (self.updatedBrands[offer.options.brand_id] / self.brands[offer.options.brand_id]) * 100;
                                brandDiscount = (offer.options.discount * brandPercentage) / 100;
                                discount += brandDiscount;
                                self.offers[key].options.discount = brandDiscount;
                            }
                        }
                    });
                    self.discount = discount;
                    
                    self.delivery_charge = (self.order.delivery_charge * percentage) / 100;
                    
                    self.total = self.subtotal - self.discount + self.delivery_charge;
                    if (self.total >= self.order.account_credit) {
                        self.account_credit = self.order.account_credit;
                    } else {
                        self.account_credit = self.total;
                        self.refundable_account_credit = self.order.account_credit - self.total;
                    }
                    
                    self.total -= self.account_credit;
                }
            },
            acceptOrder() {
                let self = this;
                let message = `You are accepting revised order of Rs.${self.subtotal} out of total order value of Rs.${self.order.subtotal}. Click 'OK' if you have checked the data or click on 'Cancel' if you want to revise further`;
                if (confirm(message)) {
                    let data = {
                        items: self.items,
                        offers: self.offers,
                        subtotal: self.subtotal,
                        discount: self.discount,
                        cart_discount: self.cart_discount,
                        delivery_charge: self.delivery_charge,
                        account_credit: self.account_credit,
                        total: self.total,
                        refundable_account_credit: self.refundable_account_credit,
                        order_id: self.order.id
                    };
                    let postUrl = `${self.appUrl}/seller/orders/${self.order.order_number}/accept`;
                    axios.post(postUrl, data)
                    .then(function(response) {
                        if (response.data.success) {
                            window.location.href = `${self.appUrl}/seller/orders`;
                        }
                    })
                    .catch(function (response) {
                        console.log(response);
                        alert('Something went wrong, please try again.');
                    });
                }
            }
        }
    };
</script>
